// in src/users.js
import React from 'react';
import {
   SimpleForm,
   Edit,
   ReferenceArrayInput,
   SelectArrayInput,
   ChipField,
   required,
   ReferenceInput,
   SelectInput,
   Toolbar
} from 'react-admin';
import {DeleteButton} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import {HASH_TAG, HASHTAG_CATEGORY, HASHTAG_CATEGORY_LIST} from '../../consts/Names';
import { WithProps } from '../utils/RecordWrappers';
import {SaveWithUpdateButton} from '../utils/RecordWrappers';
const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },
   formContainer: {
      padding: '1em 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));
const reWorkingRecord = (record) => {
    let newRecord = Object.assign({}, record);
   //  newRecord.image = {'src':record.image}
    if(newRecord.tags)
        newRecord.tags = record.tags.map(el=> {return el.id});
    return newRecord;
}

const reworkedData = (props) => {
   //  if (props.image.rawFile === undefined)
   //      delete props.image;
    props.ids = props.tags;
    props.image = "";
    delete props.tags;
    delete props.name;
    return Object.assign({}, props);
};
    

const EditToolbar = (props) => (
    <Toolbar {...props} className={props.className}>
       <SaveWithUpdateButton replaceFunction={reworkedData} updatedSource={HASHTAG_CATEGORY_LIST.SOURCE} redirect={`/${HASHTAG_CATEGORY_LIST.SOURCE}/`} 
       submitOnEnter={false} variant="text" />
       <DeleteButton  undoable={false} />
    </Toolbar>
 );

export const HashTagsForCategoryEdit = (props) => {
   const {theme} = props;
   const classes = useStyles(theme);

   return (
      <Edit {...props} title="Edit tags list for category"  undoable={false}>
          <WithProps callBackFunc={reWorkingRecord}>{({record,...props})=>
            <SimpleForm {...props} record={record} className={classes.formContainer} redirect="list" toolbar={<EditToolbar {...props} className={classes.toolBar}/>}>                
                <ReferenceInput
                className={classes.textFld}
                perPage={1000}
                label="Category"
                source={HASHTAG_CATEGORY_LIST.category_id}
                reference={HASHTAG_CATEGORY.SOURCE}
                validate={[required()]}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                {/* <ImageInput
                    className={classes.imageFld}
                    source={HASHTAG_CATEGORY_LIST.image}
                    label="Thumbnail image"
                    accept="image/*"
                    validate={[required()]}
                    placeholder={<p>Drop your image here</p>}>
                     <ImageField source={'src'} title="title" />
                </ImageInput > */}
                <ReferenceArrayInput
                className={classes.textFld}
                label="Related tags"
                reference={HASH_TAG.SOURCE}
                source={'tags'}
                perPage={1000}
                validate={[required()]}>
                    <SelectArrayInput >
                        <ChipField source={HASH_TAG.name}/>
                    </SelectArrayInput>
                </ReferenceArrayInput>
            </SimpleForm>  
        }
         </WithProps>
      </Edit>
   );
};
